import { render, staticRenderFns } from "./MapEditor.vue?vue&type=template&id=e672959a&scoped=true"
import script from "./MapEditor.vue?vue&type=script&lang=js"
export * from "./MapEditor.vue?vue&type=script&lang=js"
import style0 from "./MapEditor.vue?vue&type=style&index=0&id=e672959a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e672959a",
  null
  
)

export default component.exports